const DEFAULT_API_PATH = '/api';
const LOCAL_API_ORIGIN = 'http://localhost:3001';

const trimTrailingSlashes = (value) => value.replace(/\/+$/, '');

export const normalizeApiBaseUrl = (rawUrl) => {
  if (!rawUrl) return DEFAULT_API_PATH;

  const trimmed = trimTrailingSlashes(rawUrl.trim());
  if (!trimmed) return DEFAULT_API_PATH;

  return trimmed.endsWith(DEFAULT_API_PATH)
    ? trimmed
    : `${trimmed}${DEFAULT_API_PATH}`;
};

export const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
  }

  if (process.env.NODE_ENV === 'production') {
    return DEFAULT_API_PATH;
  }

  return normalizeApiBaseUrl(LOCAL_API_ORIGIN);
};

export const createApiEndpoint = (path) => {
  const endpoint = path.startsWith('/') ? path : `/${path}`;
  return endpoint.startsWith(DEFAULT_API_PATH)
    ? endpoint.slice(DEFAULT_API_PATH.length) || '/'
    : endpoint;
};

export const apiUrl = (path) => `${getApiBaseUrl()}${createApiEndpoint(path)}`;
